import { useQuery } from 'react-query';
import { authFetch } from '../../CommonUtils/authFetch';
import { urlWithParams } from '../../CommonUtils/urlWithParams';
import { useClientId } from '../../_hooks/useClientId';
import { queryKeys } from './queryKeys';
import { useFpId } from '../hooks/useFpId';
import { useSelector } from 'react-redux';
import { selectCurrentClient } from '../../CommonSelectors/CommonAreaSelector';
import { ModelGroupDTO } from '../../AdviserSettings/Page/Models/api/useModelGroupsQuery';

interface RiskProfileGoalSummaryDTO {
  riskToleranceDisclosure: string | null;
  selectedPortfolioGroupId: string | null;
  selectedPortfolioId: string | null;
  items: ModelGroupDTO[];
  riskSource: number | null;
  riskScore: number | null;
  riskScoreDescription: string | null;
  composure: {
    score: number;
    description: string;
  } | null;
  tolerance: {
    score: number;
    description: string;
  } | null;
  capacity: {
    score: number;
    description: string;
  } | null;
  riskalyseProfile: string | null;
  showRiskalysePopup: boolean;
}

interface FetchGoalsParams {
  clientId: number;
  fpId: string;
  hasOrionRiskAlyseIntegration: boolean;
}

const fetchRiskProfileGoalSummary = async ({
  clientId,
  fpId,
  hasOrionRiskAlyseIntegration,
}: FetchGoalsParams): Promise<RiskProfileGoalSummaryDTO | null> => {
  return await authFetch(
    urlWithParams('/Consumer/RiskToleranceStep2', {
      clientId,
      fpId,
      withRiskalyse: hasOrionRiskAlyseIntegration,
    }),
  );
};

export const useRiskProfileCardQuery = () => {
  const clientId = useClientId();

  const fpId = useFpId();

  const currentClient = useSelector(selectCurrentClient);

  return useQuery(
    queryKeys.RiskProfileGoalSummary(clientId, fpId),
    () =>
      fetchRiskProfileGoalSummary({
        clientId,
        fpId,
        hasOrionRiskAlyseIntegration: currentClient.HasOrionRiskAlyseIntegration,
      }),
    {
      cacheTime: 0,
      enabled: !!fpId,
    },
  );
};
